export default __webpack_public_path__ + "static/Quick-Turnarounds-8493a5427b05d8b9138dba0ccaf68bea.webp";